<template>
  <div class="doctorReportDetails scrollbar" :style="{ height: height - 140 + 'px' }">
    <div class="nav">
      <div class="blueText">
        检查报告单
      </div>
      <div class="navexplain">
        <span class="navexplaintext" v-if="reportDetails.Kind !==2">编号: {{ reportDetails.AccNo }}</span>
        <template v-if="reportDetails.PacsUrl != null && reportDetails.PacsUrl != ''">
          <div>
            <el-button class="img-btm" style="margin-right:15px" type="primary" size="mini" @click="pullImg">
              拉取影像
            </el-button>
            <el-dropdown v-if="reportDetails.PacsUrl.length > 1">
              <span class="el-dropdown-link">
                <a href="javascript:;">
                  <el-button class="img-btm" type="primary" size="mini">
                    查看影像
                  </el-button>
                </a>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(item, index) in reportDetails.PacsUrl" :key="item">
                  <a :href="item" target="_blank">影像{{ index + 1 }}</a>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <a v-else-if="reportDetails.PacsUrl.length == 1" :href="reportDetails.PacsUrl[0]" target="_blank">
              <el-button class="img-btm" type="primary" size="mini">查看影像</el-button>
            </a>
          </div>
        </template>
        <template v-if="reportDetails.AllImage != null && reportDetails.AllImage != ''">
          <a href="javascript:;" @click="gotoQcReportListViewer(0, reportDetails.AllImage)">
            <el-button class="img-btm" type="primary" size="mini">超声影像</el-button>
          </a>
        </template>
      </div>
    </div>
    <!-- nav -->
    <div class="content" :style="{ height: height - 280 + 'px' }">
      <div class="content-wrap" v-if="reportDetails.Kind !==2">
        <!-- <div class="manifestation">
          <svg-icon class="fz18 marr5" icon-class="report-user"></svg-icon>
          就诊人信息
        </div> -->
        <foldItem>
          <template #title>
            <span>
              就诊人信息
            </span>
          </template>
          <template #content>
            <div class="manifestationP">
              <el-row>
                <el-col :span="8">
                  <span>就诊人编号: {{ reportDetails.PatientNo | globalFilter }}</span>
                </el-col>
                <el-col :span="8">
                  <span v-if="reportDetails.ExaminDate">检查日期: {{ reportDetails.ExaminDate.substr(0, 10) }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <span>姓名: {{ reportDetails.PatientName | globalFilter }}</span>
                </el-col>
                <el-col :span="8">
                  <span>性别: {{ reportDetails.Gender | globalFilter }}</span>
                </el-col>
                <el-col :span="8">
                  <span>年龄: {{ reportDetails.CurrentAge | globalFilter }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <span>科室: {{ reportDetails.ApplyAdpt | globalFilter }}</span>
                </el-col>
                <el-col :span="8">
                  <span>住院号: {{ reportDetails.InhospitalNo | globalFilter }}</span>
                </el-col>
                <el-col :span="8">
                  <span>床号: {{ reportDetails.BedNo | globalFilter }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <span>检查部位: {{ reportDetails.BodyParts | globalFilter }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <span>检查项目: {{ reportDetails.CheckingItems | globalFilter }}</span>
                </el-col>
              </el-row>
            </div>
            <div class="dividingLine"></div>
          </template>
        </foldItem>
      </div>
      <div class="content-wrap" v-else>
        <foldItem>
          <template #title>
            <span>
              就诊人信息
            </span>
          </template>
          <template #content>
            <div class="manifestationP">
              <el-row>
                <el-col :span="12">
                  <span>姓名: {{ reportDetails.Patient.Name | globalFilter }}</span>
                </el-col>
                <el-col :span="12">
                  <span>性别: {{ reportDetails.Patient.Gender | globalFilter }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <span>年龄: {{ reportDetails.Patient.Age | globalFilter }}</span>
                </el-col>
                <el-col :span="12">
                  <span>科室: {{ reportDetails.Patient.Department | globalFilter }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <span>检查类型: {{ reportDetails.Patient.ModalityType | globalFilter }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <span>检查项目: {{ reportDetails.Patient.ExaminationItems | globalFilter }}</span>
                </el-col>
              </el-row>
            </div>
            <div class="dividingLine"></div>
          </template>
        </foldItem>
      </div>
      <div class="content-wrap" v-if="reportDetails.Kind ==2">
        <foldItem>
          <template #title>
            <span>
              登记信息
            </span>
          </template>
          <template #content>
            <div class="manifestationP">
              <el-row>
                <el-col :span="12">
                  <span>患者ID: {{ reportDetails.Registration.PatientId | globalFilter }}</span>
                </el-col>
                <el-col :span="12">
                  <span>身高: {{ reportDetails.Registration.Height | globalFilter }}cm</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <span>体重: {{ reportDetails.Registration.Weight | globalFilter }}kg</span>
                </el-col>
                <el-col :span="12">
                  <span>检查部位: {{ reportDetails.Registration.ExaminationSite | globalFilter }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <span>登记时间: {{ reportDetails.Registration.RegistrationTime | globalFilter }}</span>
                </el-col>
              </el-row>
            </div>
            <div class="dividingLine"></div>
          </template>
        </foldItem>
      </div>

      <div v-if="reportDetails.ModalityType == 'US'" class="usCenter content-wrap">
        <div class="manifestation">
          <svg-icon class="fz18 marr5" icon-class="report-diagnosis"></svg-icon>
          关键图
        </div>
        <template v-if="reportDetails.KeyImage != null && reportDetails.KeyImage.length > 0">
          <!-- <img v-for="(src,index) in reportDetails.KeyImage" class="KeyImageAllImg" @click="gotoKeyImage(index)" :src="src" :key="src"> -->
          <img
            v-for="(src, index) in reportDetails.KeyImage"
            class="KeyImageAllImg"
            @click="gotoQcReportListViewer(index, reportDetails.KeyImage)"
            :src="src"
            :key="src"
          />
        </template>
        <div class="dividingLine"></div>
      </div>
      <div class="content-wrap" v-if="reportDetails.Kind ==2">
        <foldItem>
          <template #title>
            <span>
              药物注射
            </span>
          </template>
          <template #content>
            <div class="manifestationP">
              <el-row>
                <el-col :span="12">
                  <span>放射药物: {{ reportDetails.Drug.Radiopharmaceutical | globalFilter }}</span>
                </el-col>
                <el-col :span="12">
                  <span>注射剂量: {{ reportDetails.Drug.InjectionDose | globalFilter }}mCi</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <span>空腹血糖: {{ reportDetails.Drug.FastingBloodGlucose | globalFilter }}mmol/L</span>
                </el-col>
              </el-row>
            </div>
          </template>
        </foldItem>
      </div>
      <div class="content-wrap" v-if="reportDetails.Kind !==2">
        <foldItem>
          <template #title>
            <span>
              病史
              </span>
            </template>
          <template #content>
            <p class="manifestationP" v-if="reportDetails.HealthHistory != null && reportDetails.HealthHistory != ''">～</p>
            <p class="manifestationP" v-else v-html="reportDetails.HealthHistory"></p>
            <div class="dividingLine"></div>
          </template>
        </foldItem>
      </div>

      <div class="content-wrap">
        <foldItem>
          <template #title>
            <span>
              影像学表现
            </span>
          </template>
          <template #content>
            <p class="manifestationP" v-if="reviewName.SubjectType == 4" v-html="reportDetails.DiagnoseWys"></p>
            <p class="manifestationP" v-else v-html="reportDetails.WysText"></p>
            <div class="dividingLine"></div>
          </template>
        </foldItem>
      </div>

      <div class="content-wrap">
        <foldItem>
          <template #title>
            <span>
              影像学诊断
            </span>
          </template>
          <template #content>
            <p class="manifestationP" v-if="reviewName.SubjectType == 4" v-html="reportDetails.DiagnoseWyg"></p>
            <p class="manifestationP" v-else v-html="reportDetails.WygText"></p>
            <div class="dividingLine"></div>
          </template>
        </foldItem>
      </div>
      
      <div class="content-wrap" v-if="reportDetails.Kind !==2">
        <foldItem>
          <template #title>
            <span>
              阴阳性
            </span>
          </template>
          <template #content>
            <p class="manifestationP" v-if="reportDetails.IsPositive == 0">未知</p>
            <p class="manifestationP" v-if="reportDetails.IsPositive == 1">阳性</p>
            <p class="manifestationP" v-if="reportDetails.IsPositive == 2">阴性</p>
            <div class="dividingLine"></div>
          </template>
        </foldItem>
      </div>
      <div class="content-wrap" v-if="reportDetails.Kind ==2">
        <foldItem>
          <template #title>
            <span>
              截图报告 （{{reportDetails.Screenshots.length || 0}}）
            </span>
          </template>
          <template #titleMore>
							<div class="patientInfoContentItemTitleMore" @click="onShowMoreImages">
								展开更多
								<i class="el-icon-more" style="transform: rotateZ(90deg);"></i>
							</div>
						</template>
          <template #content>
            <div class="patientInfoContentItemContent img-list-box" v-if="reportDetails && reportDetails.Screenshots && reportDetails.Screenshots.length > 0">
              <div class="patientInfoContentItemContentItem img-list" v-for="(item,index) in reportDetails.Screenshots" :key="index" @click="onShowMoreImages">
                <img :src="item.Address" alt="" class="patientInfoContentItemContentItemImg">
                <div class="patientInfoContentItemContentItemDesc">{{item.FileNotes || '--'}}</div>
              </div>
            </div>
          </template>
        </foldItem> 
      </div>
    </div>
    
    <div class="bottom">
      <el-row>
        <el-col :span="8">报告医师: {{ reportDetails.ReportSubmitterName }}</el-col>
        <el-col :span="8">审核医师: {{ reportDetails.FirstApproverName }}</el-col>
        <el-col :span="8" v-if="reportDetails.FirstApproveDt">
          报告时间: {{ reportDetails.FirstApproveDt.substr(0, 10) }}
        </el-col>
      </el-row>
    </div>
    <template>
      <viewer :images="viewList">
        <img v-for="src in viewList" class="AllImageImg" :src="src" :key="src" />
      </viewer>
    </template>
    <ViewImgDialog :visible.sync="imgDialogVisible" :list="imgList" />
  </div>
</template>

<script>
import Api from "../api/index.js";
import axios from "@/js/api";
import FoldItem from "./foldItem.vue";
import ViewImgDialog from "./viewImgDialog.vue";
// import { mapState, mapActions, mapMutations} from 'vuex'
export default {
  data() {
    return {
      height: `${document.documentElement.clientHeight}`,
      viewList: [],
      imgDialogVisible: false,
      imgList: [],
    };
  },
  components: {
    FoldItem,
    ViewImgDialog,
  },
  computed: {
    ...Vuex.mapState("doctor", ["reportDetails", "reviewName"]),
  },
  filters: {
    globalFilter: function(val) {
      if (val == null || val == "" || val == undefined) {
        return "-";
      } else {
        return val;
      }
    },
  },
  methods: {
    pullImg() {
      axios
        .ajaxGet("get", Api.api.doctor.GetImagesClone, {
          HospitalGuid: this.reportDetails.HospitalGuid,
          accNo: this.reportDetails.AccNo,
        }).then((res) => {
          ELEMENT.Message.success("拉取成功");
        });
    },
    gotoQcReportListViewer(index, list) {
      this.viewList = list;
      this.$viewerApi({
        options: {
          initialViewIndex: index,
        },
        images: list,
      });
    },
    onShowMoreImages() {
      this.imgList = this.reportDetails.Screenshots.map(item => {
        return {
          id: item.Id,
          url: item.Address,
          desc: item.FileNotes 
        }
      })
      this.imgDialogVisible = true
    }
  },
};
</script>

<style scoped lang="scss">
@import '../assets/style/variables.scss';
@import '../assets/style/mixin.scss';
.patientInfoContentItemContentItem {
		margin-bottom: 8px;
		span {
			font-weight: 400;
			font-size: 12px;
			// color: #FFFFFF;
			line-height: 20px;
			// text-shadow: 0px 2px 4px rgba(0,0,0,0.5);
		}
		
	}
	.patientInfoContentItemContentItem:last-child{
		margin-bottom: 0;
	}

  .img-list-box{
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		// flex-wrap: wrap;
		// gap: 16px;
		.img-list{
		display: flex;
		flex-direction: column;
		align-items: center;
		.patientInfoContentItemContentItemImg{
			width: 100px;
			height: 100px;
			border-radius: 6px;
			border: 1px solid #3D4049;
			object-fit: cover;
			margin-bottom: 8px;
		}
		.patientInfoContentItemContentItemDesc{
			@include text-color(fzColor);
			font-weight: 400;
			font-size: 14px;
		}
	}
}
</style>
